import React from "react";

const Razor_CSharp_Loops = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor CSharp Loops</h1>
      <p>This is the Razor CSharp Loops page content.</p>
    </div>
  );
};

export default Razor_CSharp_Loops;
